<app-modal-basic #modalRelatorio (closed)="destroyComponent()">
  <div class="app-modal-header">
    <h4 class="modal-title">Destinação de Recursos</h4>
  </div>
  <div class="app-modal-body">
    <form [formGroup]="impressaoForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div class="form-group col-sm-12">
          <label>Lançados até</label>
          <app-data formControlName="dataReferencia"></app-data>
          <show-errors [control]="impressaoForm.controls.dataReferencia"></show-errors>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-12">
          <div class="checkbox-fade fade-in-default">
            <label>
              <input type="checkbox" formControlName="detalharDespesas">
              <span class="cr">
                <i class="cr-icon icofont icofont-ui-check txt-default"></i>
              </span> <span>Detalhar despesas</span>
            </label>
          </div>
        </div>
      </div>

      <button type="submit" (click)="validaForm()" class="btn btn-primary ripple light">
        <i class="icofont icofont-print"> </i> Imprimir
      </button>
      <button type="button" class="btn btn-danger ripple" (click)="modalRelatorio.hide()"><i class="ti ti-close"></i>
        Cancelar
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
  </div>

</app-modal-basic>